
// Requête de synchronisation du statut actuel de pièces de vente avec la source externe
export class MajStatutPieceRequest {
  // Création
  constructor() {
    this.pieceIds = [];
  }

  // Identifiants des pièces de vente dont le statut actuel doit être synchronisé
  public pieceIds: string[];
}
